export default __webpack_public_path__ + "static/media/foto07.4f9764c4.png";